// Format a delivery ETA window from an order's estimated_delivery_min/max_days
// and paid time. Falls back to created_at if paid_at is not yet set.
export const formatEtaWindow = (order) => {
  if (!order?.estimated_delivery_min_days || !order?.estimated_delivery_max_days) return null;
  const base = new Date(order.updated_at || order.created_at);
  const minDate = new Date(base); minDate.setDate(minDate.getDate() + order.estimated_delivery_min_days);
  const maxDate = new Date(base); maxDate.setDate(maxDate.getDate() + order.estimated_delivery_max_days);
  const fmt = (d) => d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  return `${fmt(minDate)} – ${fmt(maxDate)}`;
};
